module.exports = __webpack_public_path__ + "static/media/hackerrank_logo.21e28675.svg";